import { useReveal } from "../lib/useReveal";

// Some logos use public-domain SVGs (text-mark logos) from Wikimedia Commons, downloaded into /public/logos.
// Source SVGs are black-on-transparent and rely on CSS `invert` to display white on the dark background.
const partners = [
  { name: "Universal Music Group", logo: "/logos/umg.svg", invert: true, scale: "max-h-7 md:max-h-9" },
  { name: "Sony Music", logo: "/logos/sony.svg", invert: true, scale: "max-h-7 md:max-h-10" },
  { name: "Warner Music Group", logo: "/logos/warner.svg", invert: true, scale: "max-h-6 md:max-h-8" },
  { name: "Atlantic Records", logo: "/logos/atlantic.svg", invert: true, scale: "max-h-9 md:max-h-12" },
  { name: "Interscope Records", logo: "/logos/interscope.svg", invert: true, scale: "max-h-10 md:max-h-14" },
  { name: "Def Jam Recordings", logo: "/logos/defjam.svg", invert: true, scale: "max-h-9 md:max-h-12" },
  { name: "Republic Records", logo: "/logos/republic.svg", invert: true, scale: "max-h-6 md:max-h-8" },
  { name: "Columbia Records", logo: "/logos/columbia.svg", invert: true, scale: "max-h-9 md:max-h-11" },
  { name: "RCA Records", logo: "/logos/rca.svg", invert: true, scale: "max-h-8 md:max-h-11" },
  { name: "Capitol Records", logo: "/logos/capitol.svg", invert: true, scale: "max-h-8 md:max-h-10" },
  { name: "Epic Records", logo: "/logos/epic.svg", invert: true, scale: "max-h-8 md:max-h-10" },
  { name: "Elektra Records", logo: "/logos/elektra.svg", invert: true, scale: "max-h-9 md:max-h-11" },
  { name: "Roc-A-Fella Records", logo: "/logos/rocafella.svg", invert: true, scale: "max-h-9 md:max-h-11" },
  { name: "Arista Records", logo: "/logos/arista.svg", invert: true, scale: "max-h-6 md:max-h-7" },
  { name: "Disruptor Records", logo: "/logos/disruptor.svg", invert: true, scale: "max-h-7 md:max-h-9" },
  { name: "Alamo Records", logo: "/logos/alamo.png", invert: true, scale: "max-h-6 md:max-h-8" },
  { name: "Motown Records", wordmark: "MOTOWN", style: "tracking-[0.22em] font-medium" },
  { name: "Santa Anna Records", wordmark: "SANTA ANNA", style: "tracking-[0.14em] font-light" },
  { name: "Broke Records", wordmark: "BROKE RECORDS", style: "tracking-[0.08em] font-light" },
];

export const Partners = () => {
  const headRef = useReveal();
  return (
    <section
      data-testid="partners-section"
      className="relative bg-[#050505] py-20 md:py-28 border-t border-white/5 overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 right-1/4 h-[20rem] w-[20rem] rounded-full bg-white/[0.03] blur-3xl float-slower"
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div ref={headRef} className="reveal text-center mb-12 md:mb-16">
          <h2
            data-testid="partners-heading"
            className="font-display text-3xl sm:text-4xl md:text-5xl font-light tracking-tighter leading-[1.05]"
          >
            Selected <span className="italic font-medium">Partners.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 overflow-hidden">
          {partners.map((p, i) => (
            <PartnerCell key={p.name} partner={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const PartnerCell = ({ partner, index }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`partner-${partner.name.toLowerCase().replace(/\s+/g, "-")}`}
      style={{ transitionDelay: `${index * 100}ms` }}
      className="reveal group flex items-center justify-center min-h-[110px] md:min-h-[140px] px-4 border border-white/10 -ml-px -mt-px transition-colors duration-500 hover:bg-white/[0.03]"
      title={partner.name}
    >
      {partner.logo ? (
        <img
          src={partner.logo}
          alt={partner.name}
          loading="lazy"
          className={`${partner.scale || "max-h-8 md:max-h-10"} w-auto object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-500 ${partner.invert ? "[filter:invert(1)_brightness(2)]" : ""}`}
        />
      ) : (
        <span
          className={`font-display text-xl md:text-2xl text-white/55 group-hover:text-white transition-colors duration-500 ${partner.style}`}
        >
          {partner.wordmark}
        </span>
      )}
    </div>
  );
};

export default Partners;
